import { ChatTimelineReply } from './new-widget-container/chat-room/chat-timeline/types';
import { ContactFormInitialFieldData } from '@wix/answers-api';
const storagePrefix = 'wa__';
const contactField = `${storagePrefix}widgetContactField`;
const contactFlowArticleId = `${storagePrefix}contactFlowArticleId`;
const labelsToAddOnNextSubmit = `${storagePrefix}labelsToAddOnNextSubmit`;

const CHAT_KEY = '__aw_chats';

// const sessionStorage = window ? window.sessionStorage : {
// 	setItem: (key: string, data: string) => console.log('session setItem', key, data),
// 	removeItem: (key: string) => console.log('session removeItem', key),
// 	getItem: (key: string) => console.log('session getItem', key),
// };

const safelyGetSessionStorage = () => {
	try {
		return window && window.sessionStorage;
	} catch (e) {
		return null;
	}
};

const safelySetItem = (key: string, value: any): boolean => {
	const sessionStorage = safelyGetSessionStorage();
	if (sessionStorage) {
		sessionStorage.setItem(key, JSON.stringify(value));
		return true;
	} else {
		return false;
	}
};

const safelyGetItem = (key: string) => {
	const sessionStorage = safelyGetSessionStorage();
	if (sessionStorage) {
		const strValue = sessionStorage.getItem(key);
		return strValue ? JSON.parse(strValue) : null;
	} else {
		return null;
	}
};

const safelyRemoveItem = (key: string) => {
	const sessionStorage = safelyGetSessionStorage();
	if (sessionStorage) {
		sessionStorage.removeItem(key);
	}
};

export const storeContactField = (value: any) => safelySetItem(contactField, value);

export const getStoredContactField = (): ContactFormInitialFieldData | null => safelyGetItem(contactField);

export const removeStoredContactField = () => safelyRemoveItem(contactField);

export const storeContactFlowArticleId = (value: any) => safelySetItem(contactFlowArticleId, value);

export const getStoreContactFlowArticleId = () => safelyGetItem(contactFlowArticleId);

export const removeStoreContactFlowArticleId = () => safelyRemoveItem(contactFlowArticleId);

export const getLabelsToAddOnNextSubmit = () => {
	const strValue = safelyGetItem(labelsToAddOnNextSubmit);
	return strValue ? strValue : [];
};

export const setLabelsToAddOnNextSubmit = (labelIds: string[]) => safelySetItem(labelsToAddOnNextSubmit, labelIds);

export const resetLabelsToAddOnNextSubmit = () => safelyRemoveItem(labelsToAddOnNextSubmit);

const safelyGetLocalStorage = () => {
	try {
		return window && window.localStorage;
	} catch (e) {
		return null;
	}
};

const safelySetLocalStorageItem = (key: string, value: any): boolean => {
	const localStorage = safelyGetLocalStorage();
	if (localStorage) {
		localStorage.setItem(key, JSON.stringify(value));
		return true;
	} else {
		return false;
	}
};

const safelyGetLocalStorageItem = (key: string) => {
	const localStorage = safelyGetLocalStorage();
	if (localStorage) {
		const strValue = localStorage.getItem(key);
		return strValue ? JSON.parse(strValue) : null;
	} else {
		return null;
	}
};

const safelyRemoveLocalStorageItem = (key: string) => {
	const localStorage = safelyGetLocalStorage();
	if (localStorage) {
		localStorage.removeItem(key);
	}
};

export type SavedChat = {
	ticketId: string;
	userId: string;
	systemMessages: ChatTimelineReply[];
};

const getNamespacedChatKey = (widgetId: string) => `${CHAT_KEY}_${widgetId}`;

const CHAT_EXPIRATION = 7 * 24 * 60 * 60 * 1000;

export const getChats = (widgetId: string): SavedChat[] => {
	const savedChats: SavedChat[] = safelyGetLocalStorageItem(getNamespacedChatKey(widgetId)) || [];
	const savedChatsWithDate = savedChats.map((chat) => ({lastUpdateDate: Date.now(), ...chat}));
	const nonExpiredChats = savedChatsWithDate.filter((chat) => Date.now() - chat.lastUpdateDate < CHAT_EXPIRATION);
	safelySetLocalStorageItem(getNamespacedChatKey(widgetId), nonExpiredChats);
	return nonExpiredChats;
};

export const saveChat = (widgetId: string, chat: SavedChat) => {
	const chatsToSave = [{...chat, lastUpdateDate: Date.now()}, ...getChats(widgetId)];
	safelySetLocalStorageItem(getNamespacedChatKey(widgetId), chatsToSave);
};

export const updateChat = (widgetId: string, chat: SavedChat) => {
	const chatsToSave = getChats(widgetId).map((savedChat) => {
		return savedChat.ticketId === chat.ticketId ? {...chat, lastUpdateDate: Date.now()} : savedChat;
	});
	safelySetLocalStorageItem(getNamespacedChatKey(widgetId), chatsToSave);
};

export const clearChats = (widgetId: string) => safelyRemoveLocalStorageItem(getNamespacedChatKey(widgetId));
